import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core/lib/utils';
var ListStyle = function ListStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary1 = _getThemeData.primary1;
  return css([".ant-list.ant-list{.ant-list-item:nth-of-type(2n){background-color:", ";}}"], primary1);
};
export default ListStyle;